import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Wordmark } from '../lib/ui';
import { Icon } from '../lib/icons';
import { useAuth } from '../auth/AuthContext';
import { useSeo } from '../lib/useSeo';
import ProductShareShowcase from '../components/ProductShareShowcase';

const FAQS = [
  { q: 'Peershare เก็บค่าบริการไหม?', a: 'ฟรีตลอดไป — ไม่มีค่าธรรมเนียม ไม่มีค่าสมาชิก ทั้งลูกแชร์และท้าวแชร์ใช้ได้เต็มทุกฟีเจอร์ เราจะหาโมเดลรายได้อื่นในอนาคตโดยไม่กระทบการเก็บหลักฐานของคุณ' },
  { q: 'Peershare ถือเงินของวงแชร์หรือเปล่า?', a: 'ไม่ — เราไม่ถือเงิน ไม่รับโอน ไม่มี escrow คุณตั้งวง ประมูล จ่ายเงิน นัดเจอกันเองตามปกติ Peershare เพียงบันทึกทุกเหตุการณ์ให้เป็นหลักฐานที่แก้ไขไม่ได้' },
  { q: 'ถ้ามีคนโกง/เบี้ยวจะทำอย่างไร?', a: 'ทุก event ถูกผนึกด้วย SHA-256 + ลายเซ็นดิจิทัล เมื่อเกิดข้อพิพาท คุณขอ "ซองหลักฐานปิดผนึก" ที่ตรวจสอบย้อนหลังได้ เพื่อนำไปใช้เจรจาหรือดำเนินคดีตามกฎหมาย' },
  { q: 'ถูกกฎหมายไหม?', a: 'ระบบช่วยตรวจกฎ พ.ร.บ. การเล่นแชร์ พ.ศ. 2534 อัตโนมัติเมื่อตั้งวง (ไม่เกิน 30 คน · ยอดรวมไม่เกิน 300,000 บาทต่อวง · ท้าวไม่เกิน 3 วงพร้อมกัน)' },
  { q: 'ต้องสมัครก่อนใช้ไหม?', a: 'ไม่ต้อง — สำรวจวงใกล้คุณและอ่านคู่มือเล่นแชร์ได้ฟรีทันที พร้อมเมื่อไหร่ค่อยเข้าสู่ระบบด้วย Google เพื่อเข้าร่วมวงหรือเป็นท้าว' },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="faq-item" onClick={() => setOpen(o => !o)} className="ps-press"
      style={{ background: PS.surface2, border: `1px solid ${PS.line}`, borderRadius: 14, padding: '16px 18px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
        <div style={{ fontSize: 14.5, fontWeight: 600, letterSpacing: -0.2 }}>{q}</div>
        <div style={{ flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }}>
          <Icon.chevronD size={18} stroke={PS.textMuted} />
        </div>
      </div>
      {open && <div className="ps-fade" style={{ fontSize: 13, color: PS.textMuted, lineHeight: 1.65, marginTop: 10 }}>{a}</div>}
    </div>
  );
}

function Footer({ nav }) {
  const link = (label, fn, testid) => (
    <button data-testid={testid} onClick={fn} className="ps-press"
      style={{ background: 'transparent', border: 'none', color: 'rgba(245,241,234,0.7)', fontSize: 13, fontFamily: PS.fontUI, textAlign: 'left', padding: 0, cursor: 'pointer' }}>{label}</button>
  );
  return (
    <footer data-testid="landing-footer" style={{ background: PS.ink, color: PS.page, marginTop: 40 }}>
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '48px 24px 28px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 28 }}>
        <div>
          <Wordmark color={PS.page} size={22} />
          <div style={{ fontSize: 12.5, color: 'rgba(245,241,234,0.6)', marginTop: 12, lineHeight: 1.6, maxWidth: 240 }}>
            คนกลางผู้เก็บหลักฐานของวงแชร์ — ฟรีตลอดไป ถูกต้องตาม พ.ร.บ. การเล่นแชร์ พ.ศ. 2534
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.45)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 2 }}>ผลิตภัณฑ์</div>
          {link('หลักการทำงาน', () => nav('/about'), 'footer-about')}
          {link('สำหรับท้าวแชร์', () => nav('/host'), 'footer-host')}
          {link('สำรวจวงแชร์', () => nav('/app/discover'), 'footer-discover')}
          {link('ตรวจสอบซองหลักฐาน', () => nav('/verify'), 'footer-verify')}
          {link('คู่มือเล่นแชร์ปลอดภัย', () => nav('/guide'), 'footer-learn')}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.45)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 2 }}>นโยบาย</div>
          {link('นโยบายความเป็นส่วนตัว', () => nav('/about'), 'footer-privacy')}
          {link('ข้อกำหนดการใช้งาน', () => nav('/about'), 'footer-terms')}
          {link('พ.ร.บ. การเล่นแชร์ 2534', () => nav('/guide/share-law-2534'), 'footer-law')}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.45)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 2 }}>ติดต่อ</div>
          <div style={{ fontSize: 13, color: 'rgba(245,241,234,0.7)' }}>support@peershare.net</div>
          <div style={{ fontSize: 13, color: 'rgba(245,241,234,0.7)' }}>LINE: @peershare</div>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(245,241,234,0.1)' }}>
        <div style={{ maxWidth: 1120, margin: '0 auto', padding: '16px 24px', fontSize: 11.5, color: 'rgba(245,241,234,0.5)' }}>
          © 2026 Peershare · เปียแชร์ — เราไม่ถือเงิน ไม่ตัดสินข้อพิพาท ไม่เป็นคู่สัญญา · เราเก็บหลักฐานให้คุณเท่านั้น
        </div>
      </div>
    </footer>
  );
}

const Pillar = ({ color, h, s, items }) => (
  <div className="ps-fade-up" style={{ background: PS.surface2, border: `1px solid ${PS.line}`, borderRadius: 16, padding: 22 }}>
    <div style={{ width: 8, height: 8, background: color, transform: 'rotate(45deg)', marginBottom: 12 }} />
    <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: -0.2 }}>{h}</div>
    <div style={{ fontSize: 12, color: PS.textMuted, marginTop: 3 }}>{s}</div>
    <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 9 }}>
      {items.map((it, k) => (
        <div key={k} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
          <div style={{ width: 5, height: 5, borderRadius: '50%', background: color, marginTop: 7, flexShrink: 0 }} />
          <div style={{ fontSize: 12.5, lineHeight: 1.5 }}>{it}</div>
        </div>
      ))}
    </div>
  </div>
);

export default function Landing() {
  const nav = useNavigate();
  const { login } = useAuth();

  // SEO: keyword-rich title/description + structured data for "เปียแชร์", "เล่นแชร์".
  useSeo({
    title: 'เปียแชร์ (Peershare) — เล่นแชร์ออนไลน์ มีหลักฐานทุกขั้น ถูกกฎหมาย',
    description: 'เปียแชร์ (Peershare) แพลตฟอร์มเล่นแชร์และแชร์ซื้อของออนไลน์ ฟรีตลอดไป — คนกลางผู้เก็บหลักฐานของวงแชร์ บันทึกทุก event แบบแก้ไขไม่ได้ ค้นหาวงเล่นแชร์ใกล้คุณ ตรวจกฎ พ.ร.บ. การเล่นแชร์ พ.ศ. 2534 อัตโนมัติ',
    path: '/',
    jsonLd: [
      { '@context': 'https://schema.org', '@type': 'WebSite', name: 'เปียแชร์ Peershare',
        alternateName: ['Peershare', 'เปียแชร์', 'เล่นแชร์ออนไลน์'], url: 'https://peershare.net',
        description: 'แพลตฟอร์มเล่นแชร์ออนไลน์ ที่เก็บหลักฐานทุกขั้น ถูกต้องตามกฎหมาย' },
      { '@context': 'https://schema.org', '@type': 'Organization', name: 'เปียแชร์ Peershare',
        url: 'https://peershare.net', email: 'support@peershare.net',
        description: 'คนกลางผู้เก็บหลักฐานของวงแชร์ — เล่นแชร์อย่างมั่นใจ มีหลักฐานทุกขั้น ถูกต้องตาม พ.ร.บ. การเล่นแชร์ พ.ศ. 2534' },
      { '@context': 'https://schema.org', '@type': 'FAQPage',
        mainEntity: FAQS.map((f) => ({ '@type': 'Question', name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a } })) },
    ],
  });

  return (
    <div style={{ minHeight: '100vh', background: PS.page, color: PS.text, fontFamily: PS.fontUI }}>
      {/* Nav */}
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '22px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Wordmark size={24} />
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button data-testid="nav-host-btn" onClick={() => nav('/host')} className="ps-press"
            style={{ border: 'none', background: 'transparent', color: PS.textMuted, fontSize: 13, fontWeight: 500, fontFamily: PS.fontUI }}>
            สำหรับท้าวแชร์
          </button>
          <button data-testid="nav-about-btn" onClick={() => nav('/about')} className="ps-press"
            style={{ border: 'none', background: 'transparent', color: PS.textMuted, fontSize: 13, fontWeight: 500, fontFamily: PS.fontUI }}>
            หลักการทำงาน
          </button>
          <button data-testid="landing-login-btn" onClick={login} className="ps-press"
            style={{ background: PS.ink, color: PS.page, border: 'none', padding: '10px 18px', borderRadius: 999, fontSize: 13, fontWeight: 600, fontFamily: PS.fontUI }}>
            เข้าสู่ระบบ
          </button>
        </div>
      </div>

      {/* Hero */}
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '36px 24px 20px' }}>
        <div className="ps-fade-up" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 22 }}>
          <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center', padding: '6px 12px', borderRadius: 999, background: 'oklch(0.78 0.06 155 / 0.3)', color: 'oklch(0.34 0.08 155)', fontSize: 12, fontWeight: 600 }}>
            <Icon.shield size={13} stroke="oklch(0.38 0.08 155)" /> ถูกต้องตาม พ.ร.บ. การเล่นแชร์ พ.ศ. 2534
          </div>
          <div data-testid="hero-free-badge" style={{ display: 'inline-flex', gap: 6, alignItems: 'center', padding: '6px 12px', borderRadius: 999, background: PS.ink, color: PS.page, fontSize: 12, fontWeight: 700 }}>
            <Icon.starO size={13} stroke="oklch(0.82 0.12 82)" /> ฟรีตลอดไป · ไม่มีค่าธรรมเนียม
          </div>
        </div>
        <h1 className="ps-fade-up" style={{ fontSize: 'clamp(34px, 6vw, 60px)', fontWeight: 700, letterSpacing: -1.5, lineHeight: 1.05, margin: 0, maxWidth: 860 }}>
          เล่นแชร์อย่างมั่นใจ<br />
          <span style={{ color: PS.textMuted }}>เพราะทุกอย่างมี</span><span style={{ color: PS.terracotta }}>หลักฐาน</span>
        </h1>
        <p className="ps-fade-up" style={{ fontSize: 'clamp(15px,2.4vw,19px)', color: PS.textMuted, lineHeight: 1.6, marginTop: 20, maxWidth: 640 }}>
          Peershare เป็น<b style={{ color: PS.text }}>คนกลางผู้เก็บหลักฐาน</b>ของวงแชร์ —
          <b style={{ color: PS.text }}> เปียแชร์</b> ไม่ถือเงิน ไม่ตัดสินใคร ไม่เป็นคู่สัญญา
          ธุรกรรมทุกอย่างคุณทำกันเองตามปกติ เราแค่บันทึกทุก event ให้แบบแก้ไขไม่ได้
          พร้อมออกเป็นซองหลักฐานเมื่อเกิดข้อพิพาท
        </p>
        <div className="ps-fade-up" style={{ display: 'flex', gap: 12, marginTop: 28, flexWrap: 'wrap' }}>
          <button data-testid="hero-explore-btn" onClick={() => nav('/app')} className="ps-press"
            style={{ background: PS.ink, color: PS.page, border: 'none', padding: '15px 28px', borderRadius: 999, fontSize: 15, fontWeight: 600, display: 'flex', gap: 8, alignItems: 'center', fontFamily: PS.fontUI }}>
            สำรวจวง & ศึกษาฟรี <Icon.chevronR size={16} stroke={PS.page} />
          </button>
          <button data-testid="hero-login-btn" onClick={login} className="ps-press"
            style={{ background: 'transparent', color: PS.text, border: `1px solid ${PS.line}`, padding: '15px 24px', borderRadius: 999, fontSize: 15, fontWeight: 500, fontFamily: PS.fontUI }}>
            เข้าสู่ระบบด้วย Google
          </button>
        </div>
        <div style={{ fontSize: 12, color: PS.textDim, marginTop: 12 }}>ดูวงแชร์ใกล้คุณและคู่มือเล่นแชร์ได้ทันที — ไม่ต้องสมัคร</div>
      </div>

      {/* Product-share use cases */}
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '28px 0 8px' }}>
        <ProductShareShowcase wide />
      </div>

      {/* 3-role pillars */}
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '40px 24px 60px' }}>
        <div style={{ fontSize: 11, color: PS.textMuted, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 18 }}>หลักการ 3 บทบาท · ทำงานแบบ autopilot</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 18 }}>
          <Pillar color="oklch(0.62 0.12 38)" h="ลูกแชร์ & ท้าวแชร์" s="ดำเนินการเองทุกขั้น"
            items={['ตั้งวง ประมูล จ่ายเงิน นัดเจอ — ทำกันเองตามจริง', 'แนบสลิป/บันทึกผลเป็นหลักฐานในระบบ', 'ดูเครดิตและประวัติของกันและกัน']} />
          <Pillar color={PS.ink} h="Smart system" s="ช่วยบันทึก ไม่ต้องขออนุมัติ"
            items={['ตรวจกฎ พ.ร.บ. เล่นแชร์ อัตโนมัติเมื่อตั้งวง', 'seal ทุก event ด้วย SHA-256 + ลายเซ็นดิจิทัล', 'ไทม์ไลน์ + audit log อัตโนมัติ']} />
          <Pillar color="oklch(0.48 0.08 155)" h="Peershare" s="มีหน้าที่เดียว: custodian"
            items={['เก็บหลักฐานทุกชิ้นแบบ immutable', 'ออกซองหลักฐานปิดผนึกเมื่อมีข้อพิพาท', 'ไม่ถือเงิน ไม่ตัดสิน ไม่เป็นคู่สัญญา']} />
        </div>
      </div>

      {/* Free forever — pricing */}
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '0 24px 12px' }}>
        <div data-testid="pricing-free" style={{ background: PS.ink, color: PS.page, borderRadius: 24, padding: 'clamp(28px,5vw,48px)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center', padding: '6px 12px', borderRadius: 999, background: 'rgba(245,241,234,0.1)', color: 'oklch(0.82 0.12 82)', fontSize: 12, fontWeight: 700, marginBottom: 18 }}>
            <Icon.starO size={13} stroke="oklch(0.82 0.12 82)" /> ราคา
          </div>
          <div style={{ fontSize: 'clamp(30px,5vw,48px)', fontWeight: 700, letterSpacing: -1.5, lineHeight: 1.05 }}>
            ฟรี<span style={{ color: 'oklch(0.82 0.12 82)' }}>ตลอดไป</span>
          </div>
          <p style={{ fontSize: 'clamp(14px,2vw,17px)', color: 'rgba(245,241,234,0.7)', lineHeight: 1.7, marginTop: 16, maxWidth: 620 }}>
            ไม่มีค่าธรรมเนียม ไม่มีค่าสมาชิก ไม่หักเปอร์เซ็นต์จากวงแชร์ —
            เราเชื่อว่าการมี<b style={{ color: PS.page }}>หลักฐานที่เชื่อถือได้</b>ควรเข้าถึงได้สำหรับทุกคน
            เราจะหาโมเดลรายได้อื่นในอนาคต โดยไม่กระทบการเก็บหลักฐานของคุณเลย
          </p>
          <div style={{ display: 'flex', gap: 22, marginTop: 26, flexWrap: 'wrap' }}>
            {['ทุกฟีเจอร์ใช้ได้เต็ม', 'ลูกแชร์ & ท้าวแชร์ ฟรีทั้งคู่', 'ไม่มีบัตรเครดิต ไม่มีกับดัก'].map((t) => (
              <div key={t} style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13.5, color: 'rgba(245,241,234,0.85)' }}>
                <div style={{ width: 18, height: 18, borderRadius: 9, background: 'oklch(0.48 0.08 155)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon.check size={12} stroke="#fff" sw={2.5} /></div>{t}
              </div>
            ))}
          </div>
          <button data-testid="pricing-cta-btn" onClick={() => nav('/app')} className="ps-press"
            style={{ marginTop: 28, background: PS.page, color: PS.ink, border: 'none', padding: '14px 26px', borderRadius: 999, fontSize: 14.5, fontWeight: 700, display: 'inline-flex', gap: 8, alignItems: 'center', fontFamily: PS.fontUI }}>
            เริ่มใช้ฟรี <Icon.chevronR size={16} stroke={PS.ink} />
          </button>
          <div style={{ position: 'absolute', right: -40, bottom: -40, width: 200, height: 200, border: '1px solid rgba(245,241,234,0.07)', transform: 'rotate(45deg)' }} />
        </div>
      </div>

      {/* FAQ */}
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '44px 24px 8px' }}>
        <div style={{ fontSize: 11, color: PS.textMuted, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>คำถามที่พบบ่อย</div>
        <h2 style={{ fontSize: 'clamp(24px,4vw,34px)', fontWeight: 700, letterSpacing: -0.8, margin: '0 0 22px' }}>สงสัยอะไร ถามได้เลย</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {FAQS.map((f) => <FaqItem key={f.q} q={f.q} a={f.a} />)}
        </div>
      </div>

      <Footer nav={nav} />
    </div>
  );
}
